var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyboxDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#012234"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#2C5369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 26C14 22.2288 14 20.3431 15.1716 19.1716C16.3431 18 18.2288 18 22 18H26C29.7712 18 31.6569 18 32.8284 19.1716C34 20.3431 34 22.2288 34 26C34 29.7712 34 31.6569 32.8284 32.8284C31.6569 34 29.7712 34 26 34H22C18.2288 34 16.3431 34 15.1716 32.8284C14 31.6569 14 29.7712 14 26Z",
    stroke: "#EBF0F3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18C28 16.1144 28 15.1716 27.4142 14.5858C26.8284 14 25.8856 14 24 14C22.1144 14 21.1716 14 20.5858 14.5858C20 15.1716 20 16.1144 20 18",
    stroke: "#EBF0F3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.3333C25.1046 29.3333 26 28.5871 26 27.6667C26 26.7462 25.1046 26 24 26C22.8954 26 22 25.2538 22 24.3333C22 23.4129 22.8954 22.6667 24 22.6667M24 29.3333C22.8954 29.3333 22 28.5871 22 27.6667M24 29.3333V30M24 22V22.6667M24 22.6667C25.1046 22.6667 26 23.4129 26 24.3333",
    stroke: "#EBF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyboxDark);
export default __webpack_public_path__ + "static/media/moneyboxDark.e31a6f8d2f0f279da7249746da83acf9.svg";
export { ForwardRef as ReactComponent };